
import { useState } from 'react';
import { CONTACT_CONFIG } from '../config/contact';

interface FormData {
  name: string;
  email: string;
  phone: string;
  message: string;
  privacyAccepted: boolean;
}

export const useContactForm = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const submitForm = async (formData: FormData) => {
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      // Create FormData object for FormSubmit
      const submitData = new FormData();
      
      // Add form fields
      submitData.append('name', formData.name);
      submitData.append('email', formData.email);
      submitData.append('phone', formData.phone);
      submitData.append('message', formData.message);
      
      // Add FormSubmit configuration
      submitData.append('_subject', CONTACT_CONFIG.settings.subject);
      submitData.append('_captcha', CONTACT_CONFIG.settings.captcha.toString());
      submitData.append('_autoresponse', CONTACT_CONFIG.settings.autoresponse.toString());
      
      // Add current page URL for reference
      submitData.append('_url', window.location.href);
      
      // Submit to FormSubmit
      const response = await fetch(CONTACT_CONFIG.formSubmitEndpoint, {
        method: 'POST',
        body: submitData,
        headers: {
          'Accept': 'application/json'
        }
      });

      if (response.ok) {
        setSubmitStatus('success');
        return { success: true };
      } else {
        throw new Error('Form submission failed');
      }
    } catch (error) {
      console.error('Form submission error:', error);
      setSubmitStatus('error');
      return { success: false, error };
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetStatus = () => {
    setSubmitStatus('idle');
  };

  return {
    isSubmitting,
    submitStatus,
    submitForm,
    resetStatus
  };
};
